import { readonly, ref } from 'vue'

import { PosthogFeatureFlags, posthog } from '@/lib/posthog'

const isMaintenanceModeOn = ref(false)

/**
 * Whether the `maintenance-page` kill switch is on.
 *
 * Read by `App.vue`, which swaps the whole shell for the maintenance screen. That check
 * sits above `RouterView` *and* above the `isAppLoaded` gate on purpose: a maintenance
 * window is exactly when Keycloak/`/users/me` are likely to be stalling, and a route-based
 * page would be stuck behind the bootstrap loader until the timeout elapsed.
 */
export const isMaintenanceMode = readonly(isMaintenanceModeOn)

/**
 * Kept subscribed rather than read once — PostHog re-evaluates flags after the initial
 * load (and on `identify`), so flipping the switch off returns everyone to the app on the
 * next evaluation without a reload.
 *
 * `posthog.isFeatureEnabled` directly, not `isPosthogFlagOn`: that helper treats "PostHog
 * hasn't loaded" as on, which is the right default for a feature gate and the wrong one
 * for a kill switch — it would black out the app whenever PostHog is unreachable.
 */
export const startMaintenanceModeWatch = () => {
  posthog.onFeatureFlags(() => {
    isMaintenanceModeOn.value = Boolean(
      posthog.isFeatureEnabled(PosthogFeatureFlags.MaintenancePage, {
        send_event: false,
      }),
    )
  })
}
